import {useMemo} from 'react'
import {useAuth} from '../../app/modules/auth'
import {TOP_ALERT_HEIGHT} from '../constants'

export const UseTopAlert = () => {
  const {currentUser} = useAuth()

  const visibleTopAlert = useMemo(() => !currentUser?.email_verified, [currentUser?.email_verified])
  const topAlertHeight = useMemo(() => (visibleTopAlert ? TOP_ALERT_HEIGHT : 0), [visibleTopAlert])

  return {visibleTopAlert, topAlertHeight}
}
